import { globalLocations } from "../../data/mock";
import { MapPin } from "lucide-react";
import { useScrollReveal } from "../../hooks/useScrollReveal";

export const StatsSection = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section ref={ref} className="py-20 bg-[#0F172A] relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0">
        <div className="absolute top-0 right-0 w-[300px] h-[300px] rounded-full bg-[#C8A951]/5 blur-[100px]" />
        <div className="absolute bottom-0 left-1/3 w-[200px] h-[200px] rounded-full bg-[#C8A951]/3 blur-[80px]" />
      </div>

      <div className={`relative max-w-7xl mx-auto px-6 lg:px-8 transition-all duration-700 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}>
        {/* Section Header */}
        <div className="text-center mb-14">
          <span className="text-[#C8A951] text-sm font-semibold tracking-[0.15em] uppercase mb-4 block">
            Our Global Footprint
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-white tracking-tight mb-3">
            Conferences Across the Globe
          </h2>
          <p className="text-[#94A3B8] text-lg max-w-xl mx-auto">
            34 cities across 14 countries — we connect leaders wherever innovation happens.
          </p>
        </div>

        {/* Locations Marquee */}
        <div className="relative">
          <div className="overflow-hidden">
            <div className="flex gap-3 flex-wrap justify-center">
              {globalLocations.map((loc, i) => (
                <div
                  key={i}
                  className="flex items-center gap-2 px-4 py-2.5 rounded-full border border-white/10 bg-white/5 backdrop-blur-sm"
                >
                  <MapPin className="w-3.5 h-3.5 text-[#C8A951] opacity-60" />
                  <span className="text-sm text-[#CBD5E1] whitespace-nowrap">
                    {loc}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
